export default class Context<T> {
  component: string;

  caller: string;

  meta: T;

  constructor() {
    this.component = null;
    this.caller = null;
    this.meta = null;
  }

  from(component: string): this {
    this.component = component;

    return this;
  }

  in(caller: string): this {
    this.caller = caller;

    return this;
  }

  with(meta: T): this {
    this.meta = meta;

    return this;
  }
}
